import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/auth/useAuth";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "../../assets/css/login.css";

const NODE_COUNT = 42;
const ALERT_EVERY = 7;

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { resetPasswordWithToken, message, error, loading } = useAuth();

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const logo = require("../../assets/images/logo/logo.png");

  const mismatch = password && passwordConfirm && password !== passwordConfirm;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== passwordConfirm) {
      return;
    }

    try {
      await resetPasswordWithToken(token, {
        password,
        passwordConfirm,
      });

      setTimeout(() => {
        navigate("/login");
      }, 1500);
    } catch (e) {
      // erreur déjà gérée via `error` du hook
    }
  };

  const feedback = error
    ? { type: "danger", text: error }
    : message
      ? { type: "success", text: message }
      : null;

  return (
    <div className="login-screen">
      {/* ---- Fond : grille de signaux surveillés ---- */}
      <div className="login-nodes" aria-hidden="true">
        <div className="login-nodes-sweep"></div>
        {Array.from({ length: NODE_COUNT }).map((_, i) => (
          <span
            key={i}
            className={`login-node${
              i % ALERT_EVERY === 0 ? " login-node--alert" : ""
            }`}
          />
        ))}
      </div>

      <div className="login-stage">
        {/* ---- Pitch ---- */}
        <div className="login-pitch">
          <div className="login-brand">
            <img src={logo} alt="SpyTeam" className="login-brand-logo" />
            <span className="login-brand-name">SpyTeam</span>
          </div>

          <span className="login-eyebrow">Nouveau mot de passe</span>
          <h1 className="login-headline">
            Un dernier verrou
            <br />
            avant de reprendre le contrôle.
          </h1>
          <p className="login-subtext">
            Choisissez un mot de passe robuste. Il sera immédiatement actif sur
            votre compte.
          </p>

          <div className="login-status">
            <span className="login-status-dot"></span>
            Système en ligne
          </div>
        </div>

        {/* ---- Carte ---- */}
        <div className="login-card">
          <div className="login-card-header d-lg-none">
            <img src={logo} alt="SpyTeam" className="login-brand-logo" />
            <span className="login-brand-name">SpyTeam</span>
          </div>

          <h2 className="login-title">Réinitialiser le mot de passe</h2>
          <p className="login-lead">
            Définissez et confirmez votre nouveau mot de passe.
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="login-field">
              <label htmlFor="reset-password">Nouveau mot de passe</label>
              <div className="login-input-wrap">
                <input
                  id="reset-password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="login-eye"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={
                    showPassword
                      ? "Masquer le mot de passe"
                      : "Afficher le mot de passe"
                  }
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="reset-password-confirm">
                Confirmer le mot de passe
              </label>
              <div className="login-input-wrap">
                <input
                  id="reset-password-confirm"
                  type={showPasswordConfirm ? "text" : "password"}
                  name="passwordConfirm"
                  placeholder="••••••••"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  required
                  minLength={8}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="login-eye"
                  onClick={() => setShowPasswordConfirm((v) => !v)}
                  aria-label={
                    showPasswordConfirm
                      ? "Masquer le mot de passe"
                      : "Afficher le mot de passe"
                  }
                >
                  {showPasswordConfirm ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            {mismatch && (
              <div className="login-alert login-alert--danger">
                Les mots de passe ne correspondent pas.
              </div>
            )}

            {feedback && (
              <div className={`login-alert login-alert--${feedback.type}`}>
                {feedback.text}
              </div>
            )}

            <button
              className="login-submit"
              type="submit"
              disabled={loading || password !== passwordConfirm}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                />
              ) : (
                "Valider"
              )}
            </button>

            <Link className="login-back" to="/login">
              ← Retour à la connexion
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
